// import SideMenu from '@/containers/side-menu/SideMenu.vue';
import CameraAgente from '@/pages/camera-agente/CameraAgente.vue';

export default {
  path: '/camera-agente',
  name: 'CameraAgente',
  component: CameraAgente,
  meta: {
    // hideMainMenu: true,
    role: {
      sectorId: 'dashboard',
    },
    breadcrumb: {
      title: 'Agente de Cameras',
      paths: [{ title: 'Agente de Cameras' }],
    },
  },
};
